<!-- 列車選択 -->
<template>
  <TemplateMfittBooking2 />
</template>

<script>
import TemplateMfittBooking2 from "@/views/Templates/MFITT/TemplateMfittBooking2";
import { onMounted, computed, watchEffect, ref } from "vue";

export default {
  name: "MfittBooking2",
  components: {
    TemplateMfittBooking2,
  },
  setup() {},
};
</script>
